import React from "react";
import "../style/gastrology.css";
import Servicessidebar from "../components/servicessidebar";

const gastroPoints = [
    "Ultramodern Endoscopic Ultrasound (EUS) for the Upper GI Tract (Oesophagoscopy, Gastroscopy & Duodenoscopy)",
    "Treatment for functional disorders, Liver Cirrhosis, Fatty Liver, Hepatitis B & C, Jaundice etc. Colonoscopy for Large Bowel (Colon, Rectum, Large Intestine)",
    "Endoscopic Retrograde Cholangiopancreatography (ERCP) to examine the Pancreatic & Bile Duct Liver Biopsy",
    "Colorectal Cancer Screening"
];

const surgeryPoints = [
    "Basic and Advanced Laparoscopic Surgeries",
    "Hand Assisted Laparoscopic Surgery (HALS)",
    "Hernia Surgery",
    "Oesophagus and Stomach Surgery",
    "Hepatobiliary Surgery",
    "Pancreatic Surgery",
    "Small and Large Intestine Surgery",
    "Whipple’s Surgery",
    "GI Onco Surgery"
];

const Gastrointestinal = () => {
    return (
        <div className="gastro-wrapper">
            <div className="container">
                <div className="gastro-je">

                    <div className="gastro-left">
                        <h2 className="gastro-title">GASTRO – INTESTINAL MEDICINE & ENDOSCOPY</h2>

                        <p className="gastro-description">
                            SAL’S Gastroenterology Department treats the numerous disorders associated with the
                            Digestive System including the Mouth, Oesophagus, Stomach, Liver, Pancreas, Small
                            Intestine, Large Intestine, Rectum and Anus. Our promise of personalized care is
                            coupled with superior services at highly accessible rates, ensuring complete patient
                            satisfaction, always.
                        </p>

                        <ul className="gastro-list">
                            {gastroPoints.map((text, i) => (
                                <li key={i} className="gastro-item">
                                    <span className="gastro-icon">➤</span>
                                    {text}
                                </li>
                            ))}
                        </ul>

                        <h3 className="surgery-title">Gastrointestinal Surgery</h3>

                        <p className="gastro-description">
                            SAL’S Gastrointestinal Surgery Team provides treatment for major surgical problems of
                            the Gastrointestinal tract and Hepatobiliary Tract (Liver and Gall Bladder) including
                            Cancers.
                        </p>

                        <ul className="gastro-list">
                            {surgeryPoints.map((text, i) => (
                                <li key={i} className="gastro-item">
                                    <span className="gastro-icon">{i % 2 === 0 ? "➤" : "✔"}</span>
                                    {text}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="gastro-side">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gastrointestinal;
